import MobileNavigation from './mobile-navigation';

export default MobileNavigation;
